


















import Vue from 'vue';
import HPacmanLoading from '@/ui/components/base/HPacmanLoading.vue';
import HPokeballLoading from '@/ui/components/base/HPokeballLoading.vue';

function ucFirst(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const LOADING_TYPES = ['pokeball', 'pacman'];

export default Vue.extend({
  name: 'HTransitionLoader',
  components: {
    HPacmanLoading,
    HPokeballLoading,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      default: 'pacman',
      validator(value) {
        return LOADING_TYPES.indexOf(value) !== -1;
      },
    },
    random: {
      type: Boolean,
      default: false,
    },
    appendLoader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    component(): string {
      const type = this.random
        ? LOADING_TYPES[Math.floor(Math.random() * LOADING_TYPES.length)]
        : this.type;

      return `H${ucFirst(type)}Loading`;
    },
    showContent(): boolean {
      if (this.appendLoader) {
        return true;
      }

      return !this.loading;
    },
  },
});
